import { Component, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { RouterModule } from '@angular/router';
import { FieldResource } from "../../core/modules/openapi";

@Component({
  selector: "app-select-all",
  imports: [RouterModule],
  template: `
    <div class="demo-full-width margin-top">
      <a [routerLink]="" (click)="onClick($event)">{{ field.displayName }}</a>
    </div>
  `,
  standalone: true,
  styles: []
})
export class ActionLinkComponent implements OnInit {
  field: FieldResource;
  group: FormGroup;

  constructor() { }
  ngOnInit() { }

  onClick($event: any) {
    eval("this." + this.field.action);
  }

  selectAll() {
    Object.keys(this.group.controls).forEach(key => {
      let control = this.group.controls[key];
      if (control?.value === false && control.status != 'DISABLED') {
        control.setValue(true);
      }
    });
  }
}
